
import { Component, Vue, Watch } from 'vue-property-decorator'

import BacLoggedInHeader from '@/templates/BacLoggedInHeader.vue'
import BacButton from '@/components/BacButton.vue'
import BacModal from '@/components/BacModal.vue'
import BacInput from '@/components/BacInput.vue'
import BacTextarea from '@/components/BacTextarea.vue'
import CustomerPermissionsModal from '@/components/admin/customer/CustomerPermissionsModal.vue'
import CustomerNoteModal from '@/components/admin/customer/CustomerNoteModal.vue'
import CustomerNoteRaw from '@/components/admin/customer/CustomerNoteRaw.vue'
import CustomerIbanModal from '@/components/admin/customer/CustomerIbanModal.vue'
import SearchFilterDownload from '@/components/admin/SearchFilterDownload.vue'
import CrewTable from '@/components/admin/customer/CrewTable.vue'
import MoreInfosModal from '@/components/admin/customer/MoreInfosModal.vue'
import OperatingAreaModal from '@/components/admin/customer/OperatingAreaModal.vue'
import SocialSecurityModal from '@/components/admin/customer/SocialSecurityModal.vue'
import WaitingForDownloadModal from '@/components/WaitingForDownloadModal.vue'
import ChangePasswordModal from '@/components/customer/ChangePasswordModal.vue'
import ChangeAddressModal from '@/components/customer/ChangeAddressModal.vue'
import ChangeNameModal from '@/components/customer/ChangeNameModal.vue'
import ChangeTelephoneModal from '@/components/customer/ChangeTelephoneModal.vue'
import ChangeBirthdayModal from '@/components/customer/ChangeBirthdayModal.vue'
import ChangeEmailModal from '@/components/customer/ChangeEmailModal.vue'

import { User } from '@/lib/models/User'

import sanitizeHtml from 'sanitize-html'
import UIkit from 'uikit'
import { RallyRound } from '@/lib/models/RallyRound'
import { Rally } from '../../lib/models/Rally'
import { DateUtils } from '@/lib/utils/DateUtils'
import { Country } from '../../lib/models/Country'

@Component({
  components: {
    BacLoggedInHeader,
    BacButton,
    BacModal,
    BacInput,
    BacTextarea,
    CustomerPermissionsModal,
    CustomerNoteModal,
    SearchFilterDownload,
    CustomerIbanModal,
    CustomerNoteRaw,
    CrewTable,
    MoreInfosModal,
    OperatingAreaModal,
    SocialSecurityModal,
    WaitingForDownloadModal,
    ChangePasswordModal,
    ChangeAddressModal,
    ChangeNameModal,
    ChangeTelephoneModal,
    ChangeBirthdayModal,
    ChangeEmailModal
  }
})
export default class CrewSearch extends Vue {
  User = User;

  searchResults: User[] = [];
  sanitizeHtml = sanitizeHtml;

  editedCustomerId = -1;

  view = 'rally-round'

  get search () {
    return this.$store.state.SearchFilterOptions.search
  }

  get filterRallyRoundId () {
    return this.$store.state.SearchFilterOptions.rallyRoundId
  }

  get filterRallyId () {
    return this.$store.state.SearchFilterOptions.rallyId
  }

  get editedUser () {
    const user = (
      this.searchResults.find((user) => user.id === this.editedCustomerId) ??
      new User()
    )
    return user
  }

  getRallyRoundNameById (id: number) {
    return RallyRound.getRallyRoundNameById(
      id,
      this.$store.state.Rally.rallies,
      this.$store.getters.rallyRounds
    )
  }

  get itemsByRallyRound () {
    const rallyRounds: any[] = []

    this.items.forEach(item => {
      item.crewRounds.forEach(crewRound => {
        if (!crewRound.id) {
          return
        }
        let foundRound = rallyRounds.find(round => round.id === crewRound.rallyRoundId)
        if (!foundRound) {
          rallyRounds.push({ id: crewRound.rallyRoundId, items: [] })
        }
        foundRound = rallyRounds.find(round => round.id === crewRound.rallyRoundId)

        // deep copy cause other data can be different for rally round(e.g. rally round task)
        foundRound.items.push(JSON.parse(JSON.stringify(item)))
      })
    })

    rallyRounds.map(round => {
      round.items.map((item: any) => {
        const user = this.searchResults.find(user => user.id === parseInt(item.id))
        if (!user) {
          return item
        }
        item.task = user.rallyRoundCrewTask(round.id)
      })
    })

    return rallyRounds.sort((a, b) => b.id - a.id) // sort by id desc
  }

  get items () {
    return this.searchResults.map((user) => {
      const name =
        user.firstname || user.lastname
          ? user.firstname + ' ' + user.lastname
          : 'Kein Name angegeben'
      const id = user.id ? user.id.toString() : '-'

      const email = user.email || '-'
      const telephone = user.telephone || '-'
      const address =
        user.street || user.zip || user.city
          ? `${user.street}<br>${user.zip} ${user.city}`
          : '-'
      const annotiation = user.annotiation || '-'
      let birthday = '-'
      if (user.birthday) {
        birthday = DateUtils.isoToMysql(user.birthday.replace(/-/g, '/').replace(/T.+/, '')).split(' ')[0]
      }

      const socialSecurity = user.socialSecurity || '-'
      const operatingArea = user.operatingArea || '-'
      const lastTShirtSize = user.lastTShirtSize || '-'
      const iban = user.iban || '-'

      return {
        id,
        name,
        email,
        telephone,
        lastTShirtSize,
        birthday,
        socialSecurity,
        operatingArea,
        iban,
        task: '-',
        address,
        annotiation,
        crewRounds: user.crew
      }
    })
  }

  allRallyRounds: { id: number; name: string; rallyId: number }[] = [];

  /**
   * ID -1 = not loaded
   * ID 0 = All Rounds
   * Otherwise ID = rally_round_id
   */
  get filterableRoundOptions () {
    if (!this.$store.state.LoggedInUser.user.id) {
      return [{ name: '', id: -1, rallyId: -1 }]
    }
    if (this.$store.state.LoggedInUser.user.isAdmin) {
      return [{ name: 'Alle Runden', id: 0, rallyId: -1 }, ...this.allRallyRounds]
    }
    return this.allRallyRounds
  }

  get filterableRoundOptionsFilteredByRally () {
    return this.filterableRoundOptions.filter((rallyRound) => {
      return rallyRound.rallyId === this.filterRallyId
    })
  }

  /**
   * ID -1 = not loaded
   * ID 0 = All Rallies
   * Otherwise ID = rally__id
   */
  get filterableRallies () {
    return [{ name: 'Alle Rallys', id: 0 }, ...this.allRallies]
  }

  get allRallies () {
    return this.$store.state.Rally.rallies
  }

  mounted () {
    this.searchCustomers()
    this.$store.dispatch('loadLoggedInUser')
    this.$store.dispatch('loadRallies')
  }

  @Watch('filterRallyRoundId')
  onFilterRallyRoundIdChanged () {
    this.searchCustomers()
  }

  private searchTimeout = 0;
  @Watch('search')
  onSearchChanged () {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
    this.searchTimeout = setTimeout(this.searchCustomers, 500)
  }

  async searchCustomers () {
    this.searchResults = await User.getAllCrew(this.search, this.filterRallyId, this.filterRallyRoundId)
  }

  async updateEditedUser () {
    await this.editedUser.update()
    UIkit.notification({
      message: 'Teilnehmer geupdated!',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
  }

  async downloadCSV () {
    RallyRound.downloadCrewCSV(this.filterRallyId, this.filterRallyRoundId)
  }
}
